import { WorkSessionDTO } from "../api/dtos/work-session.dto";
import { WorkSession } from "./work-session.types";

export const mapWorkSession = (dto: WorkSessionDTO): WorkSession => ({
  id: dto.id,
  uuid: dto.uuid,
  collaborator_id: dto.collaborator_id,

  hub_project_id: dto.hub_project_id,
  hub_project_name: dto.hub_project_name,

  hub_phase_id: dto.hub_phase_id,
  hub_phase_name: dto.hub_phase_name,

  hub_block_id: dto.hub_block_id,
  hub_block_name: dto.hub_block_name,

  hub_stage_id: dto.hub_stage_id,
  hub_stage_name: dto.hub_stage_name,

  category_id: dto.category_id,
  category_name: dto.category_name,

  start_at: dto.start_at,
  end_at: dto.end_at,
  total_hours: dto.total_hours,
  description: dto.description,
  reportSnapshot: dto.reportSnapshot
    ? {
        collaborator_timezone: dto.reportSnapshot.collaborator_timezone ?? null,
        business_date: dto.reportSnapshot.business_date ?? null,
        business_week_start: dto.reportSnapshot.business_week_start ?? null,
        business_month: dto.reportSnapshot.business_month ?? null,
        utc_start_at: dto.reportSnapshot.utc_start_at ?? null,
        utc_end_at: dto.reportSnapshot.utc_end_at ?? null,
      }
    : null,

  created_at: dto.created_at,
  updated_at: dto.updated_at,
});
